<template>
  <b-card-group deck>
    <b-card
      v-for="(info, index) in infos"
      :key="index"
    >
      <b-card-img
        class="card-image"
        :src="require('../assets/' + info.imageUrl)"
        alt=""
        :height="info.imageHeight"
        :width="info.imageWidth"
        left
      />
      <b-card-title>{{ info.title }}</b-card-title>
      <b-card-sub-title class="mb-2">{{ info.subtitle }}</b-card-sub-title>
    </b-card>
  </b-card-group>
</template>

<script>
export default {
  name: 'InfoCards',
  props: {
    infos: {
      type: Array,
      required: true,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.card-image {
  margin-bottom: 20px;
}
</style>
